export const RightArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
    >
      <path
        d="M15.6064 10.0456L17.1592 9.5L22.7 15.5001L17.1592 21.5L15.6064 20.9547L19.8399 16.3183H7.19995V14.6819H19.8399L15.6064 10.0456Z"
        fill="white"
      />
    </svg>
  );
};

export const AroundIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.412 7.91298C9.15897 6.16601 11.5284 5.18457 13.999 5.18457C16.4696 5.18457 18.839 6.16601 20.586 7.91298C22.333 9.65996 23.3144 12.0294 23.3144 14.5C23.3144 15.7233 23.0734 16.9346 22.6053 18.0648C22.1372 19.195 21.451 20.2219 20.586 21.0869C19.721 21.9519 18.694 22.6381 17.5639 23.1062C16.4337 23.5744 15.2223 23.8153 13.999 23.8153C12.7757 23.8153 11.5644 23.5744 10.4342 23.1062C9.30393 22.6381 8.27701 21.9519 7.412 21.0869C6.54699 20.2219 5.86082 19.195 5.39268 18.0648C4.92454 16.9346 4.68359 15.7233 4.68359 14.5C4.68359 12.0294 5.66503 9.65996 7.412 7.91298ZM8.40195 8.90293C9.7331 7.57178 11.4896 6.76372 13.352 6.61104L13.013 6.92754L13.0545 6.97199C12.0906 8.09781 11.3464 9.30716 10.8426 10.5686H7.12891C7.47456 9.96451 7.90125 9.40363 8.40195 8.90293ZM6.49928 11.9686C6.22649 12.7767 6.08359 13.6309 6.08359 14.5C6.08359 15.3617 6.22431 16.2165 6.49909 17.0308H10.3879C10.1792 16.2011 10.0722 15.3547 10.0722 14.4999C10.0722 13.645 10.1792 12.7984 10.388 11.9686H6.49928ZM11.8387 11.9686C11.5951 12.8031 11.4722 13.6508 11.4722 14.4999C11.4722 15.3489 11.595 16.1964 11.8386 17.0308H16.1667C16.4103 16.1964 16.5331 15.3489 16.5331 14.4999C16.5331 13.6508 16.4103 12.8031 16.1666 11.9686H11.8387ZM17.6173 11.9686C17.8261 12.7984 17.9331 13.645 17.9331 14.4999C17.9331 15.3547 17.8261 16.2011 17.6174 17.0308H21.4989C21.7737 16.2165 21.9144 15.3617 21.9144 14.5C21.9144 13.6309 21.7715 12.7767 21.4987 11.9686H17.6173ZM20.8691 10.5686H17.1627C16.6589 9.30716 15.9148 8.09781 14.9508 6.97199L14.9923 6.92754L14.6541 6.6117C16.5135 6.76604 18.2668 7.57369 19.596 8.90293C20.0967 9.40363 20.5234 9.96451 20.8691 10.5686ZM20.8694 18.4308H17.1629C16.6591 19.6924 15.9149 20.9019 14.9508 22.0278L14.9923 22.0723L14.654 22.3882C15.469 22.3205 16.27 22.1268 17.0281 21.8128C17.9884 21.415 18.861 20.832 19.596 20.097C20.0935 19.5995 20.5214 19.0389 20.8694 18.4308ZM15.6385 18.4308H12.3668C12.7748 19.3082 13.3209 20.163 14.0027 20.9809C14.6844 20.163 15.2305 19.3082 15.6385 18.4308ZM10.8424 18.4308H7.12861C7.47655 19.0389 7.90444 19.5995 8.40195 20.097C9.13696 20.832 10.0096 21.415 10.9699 21.8128C11.7305 22.1278 12.5342 22.3218 13.3521 22.3889L13.013 22.0723L13.0545 22.0278C12.0904 20.9019 11.3463 19.6924 10.8424 18.4308ZM15.6383 10.5686H12.3671C12.775 9.69129 13.321 8.83664 14.0027 8.01894C14.6843 8.83664 15.2304 9.69129 15.6383 10.5686Z"
        fill="black"
      />
    </svg>
  );
};

export const ArrowBottom = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.58789 14.5101L9.49243 13.3621L16.0708 19.854L22.6492 13.3621L23.5535 14.5101L16.0708 21.9138L8.58789 14.5101Z"
        fill="black"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2222 9.96111V1.22222C12.2222 0.898069 12.0934 0.587192 11.8642 0.35798C11.635 0.128769 11.3241 0 11 0C10.6758 0 10.365 0.128769 10.1358 0.35798C9.90654 0.587192 9.77777 0.898069 9.77777 1.22222V9.96111L7.06444 6.56822C6.96611 6.43733 6.84248 6.32752 6.70089 6.24532C6.5593 6.16312 6.40265 6.11021 6.24022 6.08972C6.07779 6.06923 5.9129 6.08158 5.75533 6.12604C5.59777 6.1705 5.45074 6.24616 5.32298 6.34853C5.19522 6.4509 5.08933 6.5779 5.01159 6.72198C4.93385 6.86607 4.88586 7.0243 4.87045 7.18729C4.85504 7.35028 4.87253 7.51471 4.92189 7.6708C4.97125 7.8269 5.05146 7.9715 5.15777 8.096L10.0467 14.2071C10.1612 14.3499 10.3063 14.4651 10.4713 14.5442C10.6363 14.6234 10.817 14.6645 11 14.6645C11.183 14.6645 11.3637 14.6234 11.5287 14.5442C11.6937 14.4651 11.8388 14.3499 11.9533 14.2071L16.8422 8.096C16.9485 7.9715 17.0287 7.8269 17.0781 7.6708C17.1275 7.51471 17.145 7.35028 17.1295 7.18729C17.1141 7.0243 17.0661 6.86607 16.9884 6.72198C16.9107 6.5779 16.8048 6.4509 16.677 6.34853C16.5493 6.24616 16.4022 6.1705 16.2447 6.12604C16.0871 6.08158 15.9222 6.06923 15.7598 6.08972C15.5973 6.11021 15.4407 6.16312 15.2991 6.24532C15.1575 6.32752 15.0339 6.43733 14.9356 6.56822L12.2222 9.96111Z"
        fill="url(#paint0_linear_754_3125)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.13633 15.7348L5.32644 12.2222H2.44444C1.79614 12.2222 1.17438 12.4797 0.715961 12.9381C0.257539 13.3966 0 14.0183 0 14.6666V19.5555C0 20.2038 0.257539 20.8256 0.715961 21.284C1.17438 21.7424 1.79614 21.9999 2.44444 21.9999H19.5556C20.2039 21.9999 20.8256 21.7424 21.284 21.284C21.7425 20.8256 22 20.2038 22 19.5555V14.6666C22 14.0183 21.7425 13.3966 21.284 12.9381C20.8256 12.4797 20.2039 12.2222 19.5556 12.2222H16.6736L13.8624 15.7348C13.5189 16.1642 13.0832 16.5108 12.5877 16.7489C12.0921 16.9871 11.5492 17.1108 10.9994 17.1108C10.4495 17.1108 9.90672 16.9871 9.41112 16.7489C8.91553 16.5108 8.47985 16.1642 8.13633 15.7348ZM17.1111 15.8888C16.787 15.8888 16.4761 16.0176 16.2469 16.2468C16.0177 16.476 15.8889 16.7869 15.8889 17.1111C15.8889 17.4352 16.0177 17.7461 16.2469 17.9753C16.4761 18.2045 16.787 18.3333 17.1111 18.3333H17.1233C17.4475 18.3333 17.7584 18.2045 17.9876 17.9753C18.2168 17.7461 18.3456 17.4352 18.3456 17.1111C18.3456 16.7869 18.2168 16.476 17.9876 16.2468C17.7584 16.0176 17.4475 15.8888 17.1233 15.8888H17.1111Z"
        fill="url(#paint1_linear_754_3125)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_754_3125"
          x1="2.91298"
          y1="0.999852"
          x2="20.4103"
          y2="13.2444"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7B36B6" />
          <stop offset="1" stopColor="#1BA3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_754_3125"
          x1="-3.5"
          y1="12.8888"
          x2="6.79154"
          y2="32.2556"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7B36B6" />
          <stop offset="1" stopColor="#1BA3FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      className="w-[13px] sm:w-[20px]"
    >
      <path
        d="M1.625 11.625H10.375V20.375C10.375 20.7206 10.655 21 11 21C11.345 21 11.625 20.7206 11.625 20.375V11.625H20.375C20.72 11.625 21 11.3456 21 11C21 10.6544 20.72 10.375 20.375 10.375H11.625V1.625C11.625 1.27938 11.345 1 11 1C10.655 1 10.375 1.27938 10.375 1.625V10.375H1.625C1.28 10.375 1 10.6544 1 11C1 11.3456 1.28 11.625 1.625 11.625Z"
        fill="black"
        stroke="#7B36B6"
      />
    </svg>
  );
};
export const MinusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="3"
      viewBox="0 0 20 3"
      fill="none"
      className="w-[13px] sm:w-[20px]"
    >
      <path
        d="M1.5625 2H9.4375L9.475 1.5C9.475 1.7765 9.727 2 10.0375 2C10.348 2 10.6 1.7765 10.6 1.5L10.5625 2H18.4375C18.748 2 19 1.7765 19 1.5C19 1.2235 18.748 1 18.4375 1H10.5625V2C10.5625 1.7235 10.3105 1.5 10 1.5C9.6895 1.5 9.4375 1.7235 9.4375 2V1H1.5625C1.252 1 1 1.2235 1 1.5C1 1.7765 1.252 2 1.5625 2Z"
        fill="black"
      />
      <path
        d="M9.4375 2H1.5625C1.252 2 1 1.7765 1 1.5C1 1.2235 1.252 1 1.5625 1H9.4375V2ZM9.4375 2L9.475 1.5C9.475 1.7765 9.727 2 10.0375 2C10.348 2 10.6 1.7765 10.6 1.5L10.5625 2M9.4375 2C9.4375 1.7235 9.6895 1.5 10 1.5C10.3105 1.5 10.5625 1.7235 10.5625 2M10.5625 2H18.4375C18.748 2 19 1.7765 19 1.5C19 1.2235 18.748 1 18.4375 1H10.5625V2Z"
        stroke="#7B36B6"
      />
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="inherit"
    >
      <path
        d="M16.484 11.976L22.635 6.632V17.259L16.484 11.976ZM8.558 12.881L10.718 14.756C11.057 15.044 11.499 15.218 11.982 15.218H11.999H12.012C12.496 15.218 12.938 15.043 13.281 14.753L13.278 14.755L15.438 12.88L22.004 18.519H1.995L8.558 12.881ZM1.986 5.365H22.016L12.395 13.721C12.2873 13.8074 12.1531 13.854 12.015 13.853H12.001H11.988C11.8495 13.854 11.7148 13.807 11.607 13.72L11.608 13.721L1.986 5.365ZM1.365 6.631L7.515 11.975L1.365 17.255V6.631ZM22.965 4.19C22.725 4.07 22.443 4 22.144 4H1.859C1.56929 4.00115 1.28367 4.06853 1.024 4.197L1.035 4.192C0.724866 4.34548 0.463696 4.58244 0.280854 4.87622C0.0980128 5.17 0.00074936 5.50897 0 5.855L0 18.027C0.000529404 18.5196 0.196452 18.9919 0.54478 19.3402C0.893108 19.6885 1.36539 19.8845 1.858 19.885H22.141C22.6336 19.8845 23.1059 19.6885 23.4542 19.3402C23.8025 18.9919 23.9985 18.5196 23.999 18.027V5.855C23.999 5.128 23.58 4.498 22.97 4.195L22.959 4.19H22.965Z"
        fill="inherit"
      />
    </svg>
  );
};

export const FlagIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="28"
      viewBox="0 0 38 28"
      fill="none"
    >
      <path
        d="M0.0831299 1.58985C0.0831299 1.119 0.464828 0.737305 0.935677 0.737305H36.7426C37.2135 0.737305 37.5952 1.119 37.5952 1.58985V26.6791C37.5952 27.1499 37.2135 27.5316 36.7426 27.5316H0.935676C0.464827 27.5316 0.0831299 27.1499 0.0831299 26.6791V1.58985Z"
        fill="#E92B2B"
        fillOpacity="0.8"
      />
      <path
        d="M0.0831299 20.8335H37.5952V24.1828H0.0831299V20.8335Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M0.0831299 14.1343H37.5952V17.4836H0.0831299V14.1343Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M0.0831299 7.43604H37.5952V10.7853H0.0831299V7.43604Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M0.0831299 1.58985C0.0831299 1.119 0.464828 0.737305 0.935677 0.737305H36.7426C37.2135 0.737305 37.5952 1.119 37.5952 1.58985V4.0866H0.0831299V1.58985Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M0.0831299 1.58985C0.0831299 1.119 0.464828 0.737305 0.935677 0.737305H17.4994V14.1345H0.0831299V1.58985Z"
        fill="#5251B7"
      />
      <path
        d="M2.78172 2.24463L3.08251 3.17037H4.05587L3.2684 3.74252L3.56918 4.66818L2.78172 4.09603L1.99425 4.66818L2.29504 3.74252L1.50757 3.17037H2.48093L2.78172 2.24463Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M2.78172 6.26367L3.08251 7.18942H4.05587L3.2684 7.76156L3.56918 8.68722L2.78172 8.11508L1.99425 8.68722L2.29504 7.76156L1.50757 7.18942H2.48093L2.78172 6.26367Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M2.78172 10.2827L3.08251 11.2085H4.05587L3.2684 11.7806L3.56918 12.7063L2.78172 12.1341L1.99425 12.7063L2.29504 11.7806L1.50757 11.2085H2.48093L2.78172 10.2827Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M6.80136 2.24463L7.10213 3.17037H8.07551L7.28801 3.74252L7.58886 4.66818L6.80136 4.09603L6.01394 4.66818L6.31471 3.74252L5.52722 3.17037H6.50059L6.80136 2.24463Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M6.80136 6.26367L7.10213 7.18942H8.07551L7.28801 7.76156L7.58886 8.68722L6.80136 8.11508L6.01394 8.68722L6.31471 7.76156L5.52722 7.18942H6.50059L6.80136 6.26367Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M6.80136 10.2827L7.10213 11.2085H8.07551L7.28801 11.7806L7.58886 12.7063L6.80136 12.1341L6.01394 12.7063L6.31471 11.7806L5.52722 11.2085H6.50059L6.80136 10.2827Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M10.8203 2.24463L11.1211 3.17037H12.0945L11.3069 3.74252L11.6078 4.66818L10.8203 4.09603L10.0329 4.66818L10.3336 3.74252L9.54614 3.17037H10.5195L10.8203 2.24463Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M10.8203 6.26367L11.1211 7.18942H12.0945L11.3069 7.76156L11.6078 8.68722L10.8203 8.11508L10.0329 8.68722L10.3336 7.76156L9.54614 7.18942H10.5195L10.8203 6.26367Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M10.8203 10.2827L11.1211 11.2085H12.0945L11.3069 11.7806L11.6078 12.7063L10.8203 12.1341L10.0329 12.7063L10.3336 11.7806L9.54614 11.2085H10.5195L10.8203 10.2827Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M14.8396 2.24463L15.1403 3.17037H16.1137L15.3262 3.74252L15.6271 4.66818L14.8396 4.09603L14.0522 4.66818L14.3529 3.74252L13.5654 3.17037H14.5388L14.8396 2.24463Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M14.8396 6.26367L15.1403 7.18942H16.1137L15.3262 7.76156L15.6271 8.68722L14.8396 8.11508L14.0522 8.68722L14.3529 7.76156L13.5654 7.18942H14.5388L14.8396 6.26367Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
      <path
        d="M14.8396 10.2827L15.1403 11.2085H16.1137L15.3262 11.7806L15.6271 12.7063L14.8396 12.1341L14.0522 12.7063L14.3529 11.7806L13.5654 11.2085H14.5388L14.8396 10.2827Z"
        fill="#FBFBFB"
        fillOpacity="0.8"
      />
    </svg>
  );
};

export const ArrowRightBlack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
    >
      <path
        d="M9.42208 0.886401L11.1625 0.274902L17.3728 6.99995L11.1625 13.7248L9.42208 13.1136L14.1671 7.91701H0V6.08289H14.1671L9.42208 0.886401Z"
        fill="black"
      />
    </svg>
  );
};

export const ActivePaginationStyle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="28"
      viewBox="0 0 8 28"
      fill="none"
    >
      <path
        d="M4 24L4 4"
        stroke="url(#paint0_linear_336_5694)"
        stroke-width="8"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_336_5694"
          x1="7"
          y1="4"
          x2="7"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1BA3FF" />
          <stop offset="1" stop-color="#7B36B6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const PaginationStyle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="9"
      viewBox="0 0 8 9"
      fill="none"
    >
      <path
        d="M4 5L4 4"
        stroke="url(#paint0_linear_336_5697)"
        stroke-opacity="0.5"
        stroke-width="8"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_336_5697"
          x1="7"
          y1="4"
          x2="7"
          y2="5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1BA3FF" />
          <stop offset="1" stop-color="#7B36B6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CloseIcon
 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="inherit"
      height="inherit"
      viewBox="0 0 20 20"
      fill="inherit"
    >
      <path
        d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L10 9.29289L14.6464 4.64645C14.8417 4.45118 15.1583 4.45118 15.3536 4.64645C15.5488 4.84171 15.5488 5.15829 15.3536 5.35355L10.7071 10L15.3536 14.6464C15.5488 14.8417 15.5488 15.1583 15.3536 15.3536C15.1583 15.5488 14.8417 15.5488 14.6464 15.3536L10 10.7071L5.35355 15.3536C5.15829 15.5488 4.84171 15.5488 4.64645 15.3536C4.45118 15.1583 4.45118 14.8417 4.64645 14.6464L9.29289 10L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
        fill="inherit"
      />
    </svg>
  );
};



export function CopyIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={props.width || "24"}
      height={props.height || "24"}
      className={props.className}
      {...props}
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>
  );
}